import { createFileRoute } from "@tanstack/react-router";
import { AuthCard } from "@/components/common/AuthCard";
import { Button } from "@/components/ui/button";

/** Fallback page for Android magic links when the App Link did not open the app. */
export const Route = createFileRoute("/m/auth")({
  validateSearch: (s: Record<string, unknown>) => ({ t: typeof s.t === "string" ? s.t : "" }),
  component: MobileAuthPage,
});

function MobileAuthPage() {
  const { t } = Route.useSearch();
  const deep = `tunictracker://auth?t=${encodeURIComponent(t)}`;
  return (
    <AuthCard title="Open in the Tunic Tracker app" subtitle="This sign-in link is for the mobile app.">
      <Button asChild className="w-full">
        <a href={deep}>Open the app</a>
      </Button>
      <p className="mt-4 text-sm text-muted-foreground">
        If nothing happens, open the app and enter the 6-digit code from the same email instead.
      </p>
    </AuthCard>
  );
}
